<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <b-row class="mb-3">
      <b-col cols="9" sm="6">
        <label>{{ $t("resolutions.libelle_sous_resolution") }}</label>
        <ValidationProvider v-slot="{ errors, classes }" :name="'nom'" rules="required">
          <b-input v-model="childResolution.name" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col cols="12" sm="6">
        <label for="position">Position</label>
        <b-form-input
          id="position"
          v-model="childResolution.position"
          type="number"
          :min="1"
          disabled
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Details -->
      <b-col>
        <label>{{ $t("resolutions.details_sous_resolution") }}</label>
        <tiptap
          v-model="childResolution.description"
          @updateOnFocusOut="updateResolutionDescription"
        />
      </b-col>
    </b-row>

    <!-- cancel, create -->
    <b-row class="mt-5 mb-2 justify-content-end">
      <b-col cols="auto">
        <b-button class="button btn-danger" @click="close">
          <font-awesome-icon icon="times-circle" />
          <span>{{ $t("general.cancel") }}</span>
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button :disabled="isLoadingSave" class="button btn-blue" @click="handleSubmit(save)">
          <font-awesome-icon v-if="!isLoadingSave" icon="save" />
          <font-awesome-icon v-else icon="spinner" pulse />
          <span>{{ $t("general.enregistrer") }}</span>
        </b-button>
      </b-col>
    </b-row>
  </ValidationObserver>
</template>

<script>
import MeetingResolutionMW from "@/middlewares/MeetingResolution";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";
import Tiptap from "@/components/snippets/Tiptap.vue";

export default {
  components: {
    Tiptap,
  },
  props: {
    parentResolution: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
      isLoadingSave: false,
      childResolution: {
        position:
          MeetingResolutionORM.query()
            .where(mt => {
              return mt.parent_resolution_id == this.parentResolution.id;
            })
            .get().length + 1,
        name: "",
        description: "",
      },
    };
  },
  methods: {
    close() {
      this.$emit("closeModal");
    },
    save() {
      this.isLoadingSave = true;
      MeetingResolutionMW.POST_MULTIPLE_CHILD_RESOLUTIONS(
        [this.childResolution],
        this.parentResolution
      )
        .then(res => {
          this.isLoadingSave = false;
          // console.log("res", res);
          this.$emit("closeModal");
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("error", err);
        });
    },
    updateResolutionDescription(description) {
      this.childResolution.description = description;
    },
  },
};
</script>
